export default "__VITE_ASSET__Bdz0qjpZ__"